import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/modules/shared.module';
import { UtilsModule } from '@app/modules/utils.module';
import { SideBannerTopWinnerComponent } from '@components/topWinner/side-banner-top-winner.component';

@NgModule({
  declarations: [SideBannerTopWinnerComponent],
  exports: [SideBannerTopWinnerComponent],
  imports: [CommonModule, SharedModule, UtilsModule],
})
export class TopWinnerModule {}
